import { render, staticRenderFns } from "./PFEfficiency.vue?vue&type=template&id=4dd97b22"
import script from "./PFEfficiency.vue?vue&type=script&lang=js"
export * from "./PFEfficiency.vue?vue&type=script&lang=js"
import style0 from "./PFEfficiency.vue?vue&type=style&index=0&id=4dd97b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports